'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _TimezoneTypes = require('../constants/TimezoneTypes');

var _TimezoneTypes2 = _interopRequireDefault(_TimezoneTypes);

var _formatShortDate = require('../utils/formatShortDate');

var _formatShortDate2 = _interopRequireDefault(_formatShortDate);

var _formatMediumDate = require('../utils/formatMediumDate');

var _formatMediumDate2 = _interopRequireDefault(_formatMediumDate);

var _formatShortMonthYear = require('../utils/formatShortMonthYear');

var _formatShortMonthYear2 = _interopRequireDefault(_formatShortMonthYear);

var _formatMediumMonthYear = require('../utils/formatMediumMonthYear');

var _formatMediumMonthYear2 = _interopRequireDefault(_formatMediumMonthYear);

var _formatShortQuarterYear = require('../utils/formatShortQuarterYear');

var _formatShortQuarterYear2 = _interopRequireDefault(_formatShortQuarterYear);

var _formatShortFullDate = require('../utils/formatShortFullDate');

var _formatShortFullDate2 = _interopRequireDefault(_formatShortFullDate);

var _formatMediumFullDate = require('../utils/formatMediumFullDate');

var _formatMediumFullDate2 = _interopRequireDefault(_formatMediumFullDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extraFormats = {
  'short-date': _formatShortDate2.default,
  'medium-date': _formatMediumDate2.default,
  'short-full-date': _formatShortFullDate2.default,
  'medium-full-date': _formatMediumFullDate2.default,
  'short-m-y': _formatShortMonthYear2.default,
  'medium-m-y': _formatMediumMonthYear2.default,
  'short-q-y': _formatShortQuarterYear2.default
};

exports.default = (0, _createReactClass2.default)({
  propTypes: {
    format: _propTypes2.default.string,
    type: _propTypes2.default.oneOf([_TimezoneTypes2.default.PORTAL, _TimezoneTypes2.default.USER, _TimezoneTypes2.default.UTC]).isRequired,
    value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.number, _propTypes2.default.array]).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      type: _TimezoneTypes2.default.PORTAL
    };
  },
  render: function render() {
    var _props = this.props,
        value = _props.value,
        format = _props.format,
        type = _props.type;

    var specialFormatter = extraFormats[format];
    var date = '';
    if (specialFormatter) {
      date = specialFormatter(value, type);
    } else {
      date = _I18n2.default.moment[type](value).format(format);
    }

    return _react2.default.createElement(
      'span',
      null,
      date
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/js/components/FormattedDateTime.js
// module id = 526
// module chunks = 177